<div class="w-full max-w-5xl p-8">
    <div class="prose prose-sm !max-w-100 col-span-4 mb-[20px]">
        @if (selectedPanelIndex == 0) {
            <h2>{{ 'label_persons_registers_iceland' | translate }}</h2>
        } @else {
            <h2>{{ 'label_companies_registers_iceland' | translate }}</h2>
        }
    </div>
    <span class="separator-line block mb-[px]"></span>
    <br />
    <mat-tab-group
        class="sm:px-2 hjalp-tab-group"
        [animationDuration]="'0'"
        [(selectedIndex)]="selectedPanelIndex"
        (selectedTabChange)="tabChanged($event)"
    >
        <mat-tab label="Einstaklingar">
            <form [formGroup]="einstaklingarForm">
                <div class="grid sm:grid-cols-4 gap-6 w-full mt-2">
                    <div class="sm:col-span-2">
                        <mat-form-field class="fuse-mat-no-subscript w-full">
                            <mat-label>Nafn einstaklings</mat-label>
                            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:user'" matPrefix></mat-icon>
                            <input placeholder="Leitaðu eftir nafni" [formControlName]="'einstaklingarFilterNafn'" matInput />
                        </mat-form-field>
                    </div>
                    <div class="sm:col-span-2">
                        <mat-form-field class="fuse-mat-no-subscript w-full">
                            <mat-label>{{ 'label_ssn' | translate }}</mat-label>
                            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:identification'" matPrefix></mat-icon>
                            <input placeholder="Leitaðu eftir kennitölu" [formControlName]="'einstaklingarFilterKennitala'" matInput />
                        </mat-form-field>
                    </div>
                    <div class="sm:col-span-2">
                        <mat-form-field class="fuse-mat-no-subscript w-full">
                            <mat-label>{{ 'label_familynumber' | translate }}</mat-label>
                            <mat-icon class="icon-size-5" [svgIcon]="'connect_without_contact'" matPrefix></mat-icon>
                            <input
                                placeholder="Leitaðu eftir fjölskyldunúmeri"
                                [formControlName]="'einstaklingarFilterFjolskyldunumer'"
                                matInput
                            />
                        </mat-form-field>
                    </div>
                    <div class="sm:col-span-2">
                        <mat-form-field class="fuse-mat-no-subscript w-full">
                            <mat-label>{{ 'label_address' | translate }}</mat-label>
                            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:home'" matPrefix></mat-icon>
                            <input
                                placeholder="Leitaðu eftir heimilisfangi"
                                [formControlName]="'einstaklingarFilterHeimilisfang'"
                                matInput
                            />
                        </mat-form-field>
                    </div>
                </div>
                <!-- Divider -->
                <div class="mt-11 mb-1 border-t"></div>
                <!-- Actions -->
                <div class="flex items-center justify-end mt-4">
                    <button mat-stroked-button type="button" (click)="einstaklingarRevertAllChanges()" [disabled]="einstaklingarLoading">
                        Hreinsa
                    </button>
                    <button
                        class="ml-4"
                        (click)="einstaklingarFetch()"
                        mat-flat-button
                        type="submit"
                        [color]="'primary'"
                        [disabled]="einstaklingarLoading"
                    >
                        @if (!einstaklingarLoading) {
                            <span> {{ 'label_search' | translate }} </span>
                        }
                        @if (einstaklingarLoading) {
                            <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
                        }
                    </button>
                </div>
            </form>
            @if (einstaklingarFetched) {
                <div class="mt-8">
                    <div class="prose prose-sm !max-w-100 col-span-4 float-left">
                        <h2 class="mb-[0px]">Leitarniðurstöður</h2>
                        <div class="text-md text-hint sm:col-span-4 mb-[15px]">Upplýsingar sóttar þann {{ fetchedDate }}</div>
                    </div>
                    <table
                        matSort
                        (matSortChange)="einstaklingarSortData($event)"
                        mat-table
                        [dataSource]="einstaklingarDisplayedData"
                        class="w-[100%]"
                    >
                        <ng-container matColumnDef="nafn">
                            <th mat-sort-header="nafn" mat-header-cell *matHeaderCellDef>Nafn</th>
                            <td mat-cell *matCellDef="let element">
                                <a class="c-link" (click)="viewPersonDetails(element)" [matTooltip]="'Skoða ítarupplýsingar'">{{
                                    element.name
                                }}</a>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="kennitala">
                            <th mat-sort-header="kennitala" mat-header-cell *matHeaderCellDef>
                                {{ 'label_ssn' | translate }}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ formatSsn(element.ssn) }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="heimili">
                            <th mat-sort-header="heimili" mat-header-cell *matHeaderCellDef>
                                {{ 'label_address' | translate }}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.address }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="postnumer">
                            <th mat-sort-header="postnumer" mat-header-cell *matHeaderCellDef>Póstnúmer</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.postalCode }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="fjolskyldunumer">
                            <th mat-sort-header="fjolskyldunumer" mat-header-cell *matHeaderCellDef>
                                {{ 'label_familynumber' | translate }}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <a
                                    class="c-link"
                                    (click)="openEinstaklingarFamilyNumberTab(element.familyNumber)"
                                    [matTooltip]="'Leita eftir fjölskyldunúmeri'"
                                >
                                    {{ element.familyNumber }}</a
                                >
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="einstaklingarOrgColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: einstaklingarOrgColumns"></tr>
                        <tr class="mat-row" *matNoDataRow>
                            @if (einstaklingarFetched) {
                                <div class="flex items-center justify-between">
                                    <span>
                                        <div class="mt-2 ml-2 font-medium text-secondary mt-[5px]">Engir einstaklingar fundust</div>
                                    </span>
                                </div>
                            }
                        </tr>
                    </table>
                    <mat-paginator
                        #einstaklingarDisplayedDataPaginator
                        class="justify-end"
                        showFirstLastButtons
                        [pageSize]="einstaklingarPageSize"
                        [length]="einstaklingarTotalNumber"
                        [pageIndex]="einstaklingarPageNumber"
                        [pageSizeOptions]="[5, 10, 25, 50]"
                    >
                    </mat-paginator>
                </div>
            }
        </mat-tab>
        <mat-tab label="Fyrirtæki">
            <form [formGroup]="fyrirtaekiForm">
                <div class="grid sm:grid-cols-4 gap-6 w-full mt-2">
                    <div class="sm:col-span-2">
                        <mat-form-field class="fuse-mat-no-subscript w-full">
                            <mat-label>Nafn fyrirtækis</mat-label>
                            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:library'" matPrefix></mat-icon>
                            <input placeholder="Leitaðu eftir nafni" [formControlName]="'fyrirtaekiFilterNafn'" matInput />
                        </mat-form-field>
                    </div>
                    <div class="sm:col-span-2">
                        <mat-form-field class="fuse-mat-no-subscript w-full">
                            <mat-label>Kennitala</mat-label>
                            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:identification'" matPrefix></mat-icon>
                            <input placeholder="Leitaðu eftir kennitölu" [formControlName]="'fyrirtaekiFilterKennitala'" matInput />
                        </mat-form-field>
                    </div>
                    <div class="sm:col-span-2">
                        <mat-form-field class="fuse-mat-no-subscript w-full">
                            <mat-label>Póstnúmer</mat-label>
                            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:location-marker'" matPrefix></mat-icon>
                            <input placeholder="Leitaðu eftir póstnúmeri" [formControlName]="'fyrirtaekiFilterPostnumer'" matInput />
                        </mat-form-field>
                    </div>
                    <div class="sm:col-span-2">
                        <mat-form-field class="fuse-mat-no-subscript w-full">
                            <mat-label>Heimilisfang</mat-label>
                            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:home'" matPrefix></mat-icon>
                            <input placeholder="Leitaðu eftir heimilisfangi" [formControlName]="'fyrirtaekiFilterHeimilisfang'" matInput />
                        </mat-form-field>
                    </div>
                    <div class="sm:col-span-2">
                        <mat-form-field class="fuse-mat-no-subscript w-full">
                            <mat-label>Atvinnugrein (nr.)</mat-label>
                            <input placeholder="Leitaðu eftir atvinnugrein" [formControlName]="'fyrirtaekiFilterAtvinnugrein'" matInput />
                        </mat-form-field>
                    </div>
                    <div class="sm:col-span-2">
                        <mat-form-field class="fuse-mat-no-subscript w-full">
                            <mat-label>Rekstrarform</mat-label>
                            <input placeholder="Leitaðu eftir rekstrarformi" [formControlName]="'fyrirtaekiFilterRekstrarform'" matInput />
                        </mat-form-field>
                    </div>
                </div>
                <!-- Divider -->
                <div class="mt-11 mb-1 border-t"></div>
                <!-- Actions -->
                <div class="flex items-center justify-end mt-4">
                    <button mat-stroked-button type="button" (click)="fyrirtaekiRevertAllChanges()" [disabled]="fyrirtaekiLoading">
                        Hreinsa
                    </button>
                    <button
                        class="ml-4"
                        (click)="fyrirtaekiFetch()"
                        mat-flat-button
                        type="submit"
                        [color]="'primary'"
                        [disabled]="fyrirtaekiLoading"
                    >
                        @if (!fyrirtaekiLoading) {
                            <span> Leita </span>
                        }
                        @if (fyrirtaekiLoading) {
                            <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
                        }
                    </button>
                </div>
            </form>
            @if (fyrirtaekiFetched) {
                <div class="mt-8">
                    <div class="prose prose-sm !max-w-100 col-span-4 float-left">
                        <h2 class="mb-[0px]">Leitarniðurstöður</h2>
                        <div class="text-md text-hint sm:col-span-4 mb-[15px]">Upplýsingar sóttar þann {{ fetchedDate }}</div>
                    </div>
                    <table
                        matSort
                        (matSortChange)="fyrirtaekiSortData($event)"
                        mat-table
                        [dataSource]="fyrirtaekiDisplayedData"
                        class="w-[100%]"
                    >
                        <ng-container matColumnDef="nafn">
                            <th mat-sort-header="nafn" mat-header-cell *matHeaderCellDef>Nafn</th>
                            <td mat-cell *matCellDef="let element">
                                <a class="c-link" (click)="viewFirmDetails(element)" [matTooltip]="'Skoða ítarupplýsingar'"
                                    >{{ element.name
                                    }}{{
                                        element.deregistrationDate != null
                                            ? '
                (afskráð)'
                                            : ''
                                    }}</a
                                >
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="kennitala">
                            <th mat-sort-header="kennitala" mat-header-cell *matHeaderCellDef>Kennitala</th>
                            <td mat-cell *matCellDef="let element">
                                {{ formatSsn(element.idNumber) }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="postnumer">
                            <th mat-sort-header="postnumer" mat-header-cell *matHeaderCellDef>Póstnúmer</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.postalCode }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="heimili">
                            <th mat-sort-header="heimili" mat-header-cell *matHeaderCellDef>Heimilisfang</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.address }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="atvinnugrein">
                            <th mat-sort-header="atvinnugrein" mat-header-cell *matHeaderCellDef>Atvinnugrein</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.industryCode }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="rekstrarform">
                            <th mat-sort-header="rekstrarform" mat-header-cell *matHeaderCellDef>Rekstrarform</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.businessFormNew }}
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="fyrirtaekiOrgColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: fyrirtaekiOrgColumns"></tr>
                        <tr class="mat-row" *matNoDataRow>
                            @if (fyrirtaekiFetch) {
                                <div class="flex items-center justify-between">
                                    <span>
                                        <div class="mt-2 ml-2 font-medium text-secondary mt-[5px]">Engin fyrirtæki fundust</div>
                                    </span>
                                </div>
                            }
                        </tr>
                    </table>
                    <mat-paginator
                        #fyrirtaekiDisplayedDataPaginator
                        class="justify-end"
                        showFirstLastButtons
                        [pageSize]="fyrirtaekiPageSize"
                        [length]="fyrirtaekiTotalNumber"
                        [pageIndex]="fyrirtaekiPageNumber"
                        [pageSizeOptions]="[5, 10, 25, 50]"
                    >
                    </mat-paginator>
                </div>
            }
        </mat-tab>
    </mat-tab-group>
</div>
